import request from '@/config'
import { RoleBase, DeleteRoleDto, RoleSearhDto } from './dto';

enum Apis {
    Create = `/api/SysRole/InsertSysRole`,
    Modify = `/api/SysRole/UpdateSysRole`,
    List = `/api/SysRole/GetSysRolePage`,
    Detail = `/api/SysRole/GetSysRoleInfo`,
    Delete = `/api/SysRole/DeleteSysRole`,
    DropDownList = `/api/sysrole/roleselectlist`,
    SetRoleRelation = `/api/sysrole/setrolemodulesrelation`,
    GetRoleRelation = `/api/sysrole/getrolerelationlist`,
}

export const SetRoleRelationApi = (datas: any): Promise<IResponse> =>
    request.post({
        url: Apis.SetRoleRelation,
        data: datas
    })

export const GetRoleRelationApi = (roleId: string): Promise<IResponse> =>
    request.post({
        url: Apis.GetRoleRelation,
        data: { role_id: roleId }
    })

const CreateRoleApi = (inputs: RoleBase): Promise<IResponse> => {
    return request.post({ url: Apis.Create, data: inputs })
}

const ModifyRoleApi = (inputs: RoleBase): Promise<IResponse> => {
    return request.post({ url: Apis.Modify, data: inputs })
}

const GetRoleListApi = (search: RoleSearhDto): Promise<IResponse> => {
    return request.post({ url: Apis.List, data: search })
}

const GetRoleDetailApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.Detail, data: { id: rowId } })
}

const DeleteRoleApi = (deletes: DeleteRoleDto): Promise<IResponse> => {
    return request.post({ url: Apis.Delete, data: deletes })
}

/* 角色选择列表 */
const RoleDowndownListApi = (): Promise<IResponse> =>
    request.post({
        url: Apis.DropDownList,
        data: {}
    })

export {
    CreateRoleApi,
    ModifyRoleApi,
    GetRoleDetailApi,
    DeleteRoleApi,
    GetRoleListApi,
    RoleDowndownListApi
}